import React, { Component } from "react";
import { connect } from "react-redux";
import UserMenuView from "./user-menu-view";
import { logout, viewAsAdmin, viewAsBusiness } from "../auth/auth-actions";
import { getBusinessAccounts } from "../business-accounts/business-accounts-actions";
import { requestUsersList } from "../users-and-permissions/users-listing/users-listing-actions";

class UserMenu extends Component {
  componentDidMount() {
    if (this.props.auth.admin) this.props.getBusinessAccounts();
  }

  toggleViewAsBusiness = business => {
    if (this.props.auth.business === business) this.props.viewAsBusiness(null);
    if (this.props.auth.business !== business) {
      this.props.viewAsBusiness(business);
      this.props.requestUsersList({
        asBusinessId: business
      });
    }
  };

  render() {
    return (
      <UserMenuView
        {...this.props}
        toggleViewAsBusiness={this.toggleViewAsBusiness}
        loading={
          this.props.businessAccounts.isFetching &&
          this.props.businessAccounts.list.length === 0
        }
      />
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  businessAccounts: state.businessAccounts
});

const mapDispatchToProps = {
  logout: logout,
  viewAsBusiness: viewAsBusiness,
  viewAsAdmin: viewAsAdmin,
  getBusinessAccounts: getBusinessAccounts,
  requestUsersList: requestUsersList
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserMenu);



// WEBPACK FOOTER //
// ./src/components/sidebar/user-menu.js